import { render, staticRenderFns } from "./HostingSummaryCard.vue?vue&type=template&id=ac353a8a&scoped=true"
import script from "./HostingSummaryCard.vue?vue&type=script&lang=js"
export * from "./HostingSummaryCard.vue?vue&type=script&lang=js"
import style0 from "./HostingSummaryCard.vue?vue&type=style&index=0&id=ac353a8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac353a8a",
  null
  
)

export default component.exports